exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".customer-info{margin-bottom:10px;margin-top:10px;width:100%}.customer-info .label{color:#aaa}.customer-info .data,.customer-info .label{font-size:1.4rem;margin-bottom:5px}.customer-info .location{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between}.customer-info .location .data :first-child{margin-right:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/product/shared/components/dealer-info.scss
// module id = 5148
// module chunks = 0